import React from 'react';
import { Spinner } from 'react-bootstrap';
import useThunderbirdOrderList from '../hooks/reactQuery/useThunderbirdOrderList';
import ThunderbirdOrdersTable from '../components/order/ThunderbirdOrdersTable';
import useListPage from '../hooks/useListPage';
import { usePublishPageMeta } from '../context/PageMeta';

interface IProps {
  handleModalOpen: (data: any) => void;
  rowDetails: any;
  setRowDetails: any;
}

const ThunderbirdOrders = ({
  handleModalOpen,
  rowDetails,
  setRowDetails,
}: IProps) => {
  const {
    currentPage,
    setCurrentPage,
    pageSize,
    onPageSizeChange,
    isAuto,
    fitSize,
  } = useListPage(270, '');

  const { data, isLoading, isFetching, refetch, dataUpdatedAt } =
    useThunderbirdOrderList({ limit: pageSize, page: currentPage });
  usePublishPageMeta({ total: data?.total, dataUpdatedAt, refetch });

  return (
    <div className="main-content">
      <div className="page-note" role="note">
        Bulk Thunderbird orders come in from the ordernarcan.ca website.
      </div>
      {isLoading ? (
        <div className="spinner-position">
          <Spinner />
        </div>
      ) : (
        <ThunderbirdOrdersTable
          data={data}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          handleModalOpen={handleModalOpen}
          isFetching={isFetching}
          rowDetails={rowDetails}
          setRowDetails={setRowDetails}
          pageSize={pageSize}
          onPageSizeChange={onPageSizeChange}
          isAutoPageSize={isAuto}
          fitPageSize={fitSize}
        />
      )}
    </div>
  );
};

export default ThunderbirdOrders;
